import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import { CheckTreasuryShares, CreateTreasurySharesAcquisitionPayload, PrepareAmountsResponse } from '../models/treasurySharesAcquisition';

export const onCheckTreasurySharesLimit = async (number_of_treasury_shares: number) => {
	try {
		const response = await axios.post<JsonResponse<CheckTreasuryShares>>('dashboard/actions/raise-capital/check-treasury-shares-limit', {
			number_of_treasury_shares,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onPrepareAmounts = async (number_of_treasury_shares: number, share_price: number) => {
	try {
		const response = await axios.post<JsonResponse<PrepareAmountsResponse>>('dashboard/actions/raise-capital/prepare-amounts', {
			number_of_treasury_shares,
			share_price,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateTreasurySharesAcquisition = async (payload: CreateTreasurySharesAcquisitionPayload) => {
	try {
		const response = await axios.post('dashboard/actions/raise-capital/treasury-shares-acquisition', payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateTreasurySharesAcquisition = async (id: string, payload: CreateTreasurySharesAcquisitionPayload) => {
	try {
		const response = await axios.put(`dashboard/actions/raise-capital/treasury-shares-acquisition/${id}`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onExportTreasurySharesAcquisitionSellers = async (id: number) => {
	try {
		const response = await axios.get<{ message: string; excel_file_path?: string }>(
			`dashboard/actions/raise-capital/export-tsa-sellers-to-excel/${id}`,
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};
